import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { cities } from './cities.mock';
import { City } from './city.model';

@Injectable({
  providedIn: 'root',
})
export class EoCityDropdownService {
  data$ = new BehaviorSubject<City[] | null>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  init() {
    this.data$.next(null);
  }

  getCitiesOfPrefecture(
    url: string,
    prefectureId: string | number
  ): Observable<City[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}/${prefectureId}`,
      success$: this.data$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<City[]>(param);
  }

  getCitysMock(): Observable<City[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<City[]>((sub) => {
      setTimeout(() => {
        sub.next(cities);
        this.data$.next(cities);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
